import { Badge, Space } from "antd";
import { memo } from "react";

const Badges = memo(
  ({
    recordsCount,
    eventsCount,
    congestionRate,
    loadingTime,
    displayLoadingTime,
  }) => {
    return (
      <>
        <Space size={"large"}>
          <div>
            <Badge count={recordsCount} overflowCount={10000} color={"green"} />{" "}
            enregistrements
          </div>
          <div>
            <Badge count={eventsCount} overflowCount={10000} color={"blue"} />{" "}
            événements uniques
          </div>
          {congestionRate !== null && (
            <div>
              <Badge
                count={`${Math.round(congestionRate * 100)} %`}
                overflowCount={10000}
                color={"red"}
              />{" "}
              taux de congestion
            </div>
          )}
        </Space>
        {displayLoadingTime && (
          <div style={{ color: "gray" }}>
            {(loadingTime / 1000).toFixed(3)} s
          </div>
        )}
      </>
    );
  },
);

export default Badges;
